import SectionHeading from "@/components/base/SectionHeading";
import { harmTypes } from "@/mocks/site";

export default function HarmGrid() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="黑料的形态"
          title="「网暴黑料」并不只是一种骂声"
          description="它是一套组合手段。理解它的具体形态，才能判断自己正在经历什么，也才能找到对应的应对方式。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {harmTypes.map((type, index) => (
            <div
              key={type.name}
              className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-accent-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${type.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-black text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base md:text-lg font-bold text-foreground-950">
                {type.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{type.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}